import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { TONE_STYLES, nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass, toneHandleClass } from '../../nodeCatalog'

const TYPE = 'condition'
const Icon = nodeIcon(TYPE)

const ConditionNode: React.FC<NodeProps> = ({ data, selected }) => {
  // Overrides the card helper's 180px min-width — the Yes/No outlet labels sit at
  // 28% / 72% and need the extra 20px to clear each other.
  return (
    <div className={nodeCardClass(TYPE, selected)} style={{ minWidth: 200 }}>
      <Handle
        type="target"
        position={Position.Top}
        className={nodeHandleClass(TYPE)}
      />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Condition</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'If / Then'}</p>
        </div>
      </div>
      {data.condition_type && (
        <p className="mt-1 text-xs text-muted-foreground pl-10 capitalize">
          {data.condition_type.replace(/_/g, ' ')}
        </p>
      )}
      {/* Branch outputs — label sits above, dot on the bottom edge, aligned.
          Yes/No are pass/fail outlets, so they keep success/danger rather than
          inheriting the node's own tone. */}
      <div className="relative mt-4 h-4">
        <span
          className={`absolute bottom-0 -translate-x-1/2 text-[10px] font-emphasis uppercase tracking-wide ${TONE_STYLES.success.text}`}
          style={{ left: '28%' }}
        >
          Yes
        </span>
        <span
          className={`absolute bottom-0 -translate-x-1/2 text-[10px] font-emphasis uppercase tracking-wide ${TONE_STYLES.danger.text}`}
          style={{ left: '72%' }}
        >
          No
        </span>
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="yes"
        style={{ left: '28%' }}
        className={toneHandleClass('success')}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="no"
        style={{ left: '72%' }}
        className={toneHandleClass('danger')}
      />
    </div>
  )
}

export default memo(ConditionNode)
